export default {"src":"/_next/static/media/applicability.5e577d64.svg","height":830,"width":726,"blurWidth":0,"blurHeight":0};